// src/assets/svgicons/index.js
const importMetaGlob = import.meta.glob('/src/assets/svgicon/svg/*.svg', { eager: true })

const iconList = Object.keys(importMetaGlob).reduce((icons, path) => {
  const iconName = path.match(/\/([^\/]+)\.svg$/)[1]
  icons[iconName] = importMetaGlob[path].default
  return icons
}, {})

console.log(iconList, 'iconList')
export default iconList
